import { createFileRoute } from '@tanstack/react-router';

import { Layouts } from '@/pages';

export const Route = createFileRoute('/(dashboard)/layouts/')({
  component: () => <Layouts />,
});
